import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  p: (p) => p.spacing(1, 1.5, 0, 1.5),
  marginBottom: (p) => p.spacing(1),
};

export const headerTitle: SxStyle = {
  fontSize: (p) => p.typography.body3.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
  color: (p) => p.palette.grey[800],
};

export const button: SxStyle = {
  textTransform: 'none',
};
export const closeIcon: SxStyle = {
  cursor: 'pointer',
};
